export function getUrlParameterValue(value: string): string | null {
  const url = new URL(window.location.href);
  return url.searchParams.get(value);
}

export function clearAllUrlParameters(): void {
  let url = new URL(window.location.href);
  url.search = "";
  window.history.pushState({}, "", url.toString());
}

export function getAllParamsFromURL(
  path: string | null = null
): Record<string, any> {
  const urlObj = path ? new URL(path) : new URL(window.location.href);

  const params = new URLSearchParams(urlObj.search);
  const paramsObj = {} as any;

  params.forEach((value, key) => {
    paramsObj[key] = value;
  });

  return paramsObj;
}

export function setUrlParameter(key: string, value: string): void {
  const url = new URL(window.location.href);
  url.searchParams.set(key, value);
  history.pushState({}, "", url);
}

export function getPreloadClassId(url: string, query: string): string | null {
  const params = url.split("&");
  for (const param of params) {
    if (param.includes(`${query}=`)) {
      return param.split("=")[1];
    }
  }
  return null;
}

export function removeParamFromUrl(url: URL, param: string): string {
  url.searchParams.delete(param);

  return url.toString();
}

export function modifyUrlParameter(
  isActive: boolean,
  optionValue: string,
  urlParam: string
): void {
  const url = new URL(window.location.href);
  const data = url.searchParams.get(urlParam);
  if (isActive) {
    if (optionValue && data) {
      const urls = data.split(",");
      if (!urls.includes(optionValue)) {
        urls.push(optionValue);
        url.searchParams.set(urlParam, urls.join(","));
      }
    } else if (optionValue && !data) {
      url.searchParams.set(urlParam, optionValue);
    }
  } else {
    if (data) {
      const urls = data.split(",");
      const updatedUrls = urls.filter((url) => url !== optionValue);
      if (updatedUrls.length > 0) {
        url.searchParams.set(urlParam, updatedUrls.join(","));
      } else {
        url.searchParams.delete(urlParam);
      }
    }
  }

  history.pushState({}, "", url);
}

export function parseRegistrationLink(
  encodedUrl: string,
  price: string = "",
  category1: string = "",
  category2: string = ""
): string {
  let standardUrl = encodedUrl.replace(/\\/g, "").replace(/&amp;/g, "&");
  standardUrl += price ? "&price=" + price : "";
  standardUrl += category1 ? "&Cat1=" + category1 : "";
  standardUrl += category2 ? "&Cat2=" + category2 : "";

  return standardUrl;
}

export function additionalUrlParameters(
  url: string,
  price: string = "",
  category1: string = "",
  category2: string = ""
) {
  let standardUrl =
    price || category1 || category2
      ? url.includes("?")
        ? url + "&"
        : url + "?"
      : "";
  standardUrl += price ? "price=" + price : "";
  standardUrl += category1 ? "&" : "";
  standardUrl += category1 ? "Cat1=" + category1 : "";
  standardUrl += category2 ? "&" : "";
  standardUrl += category2 ? "Cat2=" + category2 : "";

  return standardUrl;
}
